


























































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetCurrentUserData } from "@/request/account";
import Copy from "@/components/copy.vue";
import Header from "../../components/common-header.vue";
import LeftNav from "../../components/left-nav.vue";
@Component({
  components: {
    Header,
    LeftNav,
    Copy
  }
})
export default class AccountManage extends Vue {
  private user: any = {};
  /**
   * @description 获取用户信息
   */
  private fetchUserData() {
    GetCurrentUserData(this).then((data: any) => {
      this.user = data;
    });
  }
  /**
   * @description 退出登录
   */
  private logout() {
    localStorage.removeItem("token");
    this.$router.push("/access/login");
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchUserData();
  }
}
